// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bey_a big_rj big_rk big_vh big_eb big_vf big_gu big_kh"};